import React, { useState } from 'react';
import { PencilSquareIcon } from '@heroicons/react/24/solid';

const BranchCard = ({ branches, handleEdit, handleToggleStatus }) => {
  const u = value => String(value ?? '').toUpperCase();

  return (
    <div className="md:hidden h-[calc(100vh-220px)] overflow-y-auto pr-1 pb-20">
        <div className="grid gap-4">
        {branches.map((branch, idx) => (
            <div key={idx} className="border rounded-md shadow p-4 bg-white">
                <div className="flex justify-between items-center">
                    <div>
                        <p className="font-semibold">{u(branch?.branch_code)}</p>
                        <p className="font-semibold">{u(branch?.contact_name)}</p>
                        <p className="text-sm text-gray-600">{branch?.contact_number}</p>
                        <div className="mt-1 text-sm text-gray-600">
                            <div>{u(branch?.address_line_1)}</div>
                            <div>{u(branch?.address_line2)}</div>
                            <div>{u(branch?.city)}</div>
                            <div>{u(branch?.state)}</div>
                            <div>{branch?.pincode}</div>
                        </div>
                    </div>
                    <button onClick={() => handleEdit(branch)}>
                        <PencilSquareIcon className="w-5 h-5 text-blue-600" />
                    </button>
                </div>
                <div className="mt-2 text-sm">
                {branch.emails?.slice(0, 2).map((email, i) => (
                    <div key={i} className="truncate">{u(email)}</div>
                ))}
                {branch.emails?.length > 2 && (
                    <button
                    onClick={() => alert(branch.emails.join('\n'))}
                    className="text-blue-600 hover:underline text-xs"
                    >
                    +{branch.emails.length - 2} more
                    </button>
                )}
                </div>

                <div className="mt-2 text-sm">
                <span
                    onClick={() => handleToggleStatus(branch)}
                    className={`cursor-pointer ${
                    branch.is_active ? 'text-green-600' : 'text-red-500'
                    } font-medium`}
                >
                    {(branch.is_active === 1) ? 'ACTIVE' : 'INACTIVE'}
                </span>
                </div>
            </div>
        ))}
        </div>
    </div>
  );
};

export default BranchCard;
